import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    close() {
        document.querySelector('.app-overlay').classList.add('d-none');
        this.element.classList.add('d-none');
        this.setCookie('app-notification', '1', 1);
    }

    setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = `; expires=${date.toUTCString()}`;
        }
        document.cookie = `${name}=${value || ""}${expires}; path=/`;
    }
}
